<template>
  <div class="container">
    <div class="row">
      <label class="col-sm-2 col-form-label">Fecha Inicial</label>
      <div class="col-sm-3">
        <datepicker v-model="dateFrom" :bootstrap-styling="true"></datepicker>
      </div>
      <div class="col-sm-1"></div>
      <label class="col-sm-2 col-form-label">Fecha Final</label>
      <div class="col-sm-3">
        <datepicker v-model="dateTo" :bootstrap-styling="true"></datepicker>
      </div>
    </div>
    <hr>
    <div class="row">
      <div class="col-sm">
        <div v-if="loading" class="jumbotron">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <table v-else class="table table-striped table-sm table-dark">
          <thead>
            <tr>
              <th scope="col">
                <select class="custom-select" v-model="employee">
                  <option selected value="0">Nombre</option>
                  <option v-for="(i, index) in users" :value="index+1">{{ i.name }} {{ i.surname }} {{ i.surname2 }}</option>
                </select>
              </th>
              <th scope="col">Fecha</th>
              <th scope="col">Hora</th>
              <th scope="col">Acción</th>
              <th scope="col">Timestamp</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(i, index) in filtered">
              <td>{{i.name}} {{i.surname}} {{i.surname2}}</td>
              <td>{{i.date}}</td>
              <td>{{i.time}}</td>
              <td>{{i.action}}</td>
              <td>{{i.truetime}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
    function parseDate(t){
      // Split timestamp into [ Y, M, D, h, m, s ]
      var t = t.split(/[- :]/);
      // Apply each element to the Date function and return
      return new Date(t[0], t[1]-1, t[2]);
    }
    import settings from "../settings";
    import axios from 'axios';
    import Datepicker from 'vuejs-datepicker';
    var API_URL = settings.API_URL + "assist/";
    var today = new Date();
    var today = new Date (today.getFullYear(), today.getMonth(), today.getDate());
    var monthFirst = new Date (today.getFullYear(), today.getMonth(), 1);
    export default {
        name: 'Assist',
        components: {
          Datepicker
        },
        data () {
            return {
                loading:true,
                users: {},
                employee: 0,
                controls: {},
                dateFrom: monthFirst,
                dateTo: today,
                alerts:[{type:'alert-warning', text:'Desarrollo en fase ALPHA -> ¡Informar inmediatamente de cualquier comportamiento extraño!'}]
            }
        },
        computed:{
          dateFilter(){
            return this.controls.filter(i => {
              var t = parseDate(i.truetime).getTime();
              return  t >= this.dateFrom.getTime() && t <= this.dateTo.getTime();
            })
          },
          filtered() {
            if (this.dateFilter.length > 0 && this.users.length > 0 && this.employee>0) {
              return this.dateFilter.filter(i => {
                return i.username == this.users[this.employee-1].username;
              })
            }else{
              return this.dateFilter;
            }
          }
        },
        methods:{
            getControls() {
                axios.post(API_URL + 'getControls.php', {
                    user: 0
                }).then((response) => {
                    this.controls = response.data;
                    this.loading = false;
                });
            },
            getUsers() {
              axios.post(API_URL + 'getUsers.php')
              .then((response) => {
                this.users = response.data;
              });
            }

        },
        mounted(){
          this.getUsers();
          this.getControls();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>